import React, { useState } from 'react';
import { ListRenderItem, FlatList } from 'react-native';

import { Modal, Searchbar, useTheme } from '@/components/ui';
import { modalStyles } from '@/styles';

type SearchModalProps<ItemT = any> = {
	isModalVisible: boolean;
	closeSearch: () => void;
	placeholder: string;
	onChangeText: (text: string) => void;
	searchQuery: string;
	filteredOptions: ItemT[];
	renderOptionItem: ListRenderItem<ItemT>;
};

export const SearchModal: React.FC<SearchModalProps> = ({
	isModalVisible,
	closeSearch,
	placeholder,
	onChangeText,
	filteredOptions,
	renderOptionItem,
}) => {
	const theme = useTheme();
	const [searchQuery, setSearchQuery] = useState('');
	let searchTimeout: ReturnType<typeof setTimeout> | null = null;

	const handleChangeText = (text: string) => {
		setSearchQuery(text);
		if (searchTimeout) {
			clearTimeout(searchTimeout);
		}
		searchTimeout = setTimeout(() => {
			onChangeText(text);
		}, 300);
	};

	return (
		<Modal
			visible={isModalVisible}
			onDismiss={closeSearch}
			style={modalStyles.modalContainer}
			contentContainerStyle={{
				flex: 1,
				justifyContent: 'flex-start',
				backgroundColor: theme.colors.background || 'white',
			}}
		>
			<Searchbar
				placeholder={placeholder}
				onChangeText={handleChangeText}
				value={searchQuery}
				autoFocus
				mode="view"
			/>
			<FlatList
				data={filteredOptions}
				keyExtractor={(item, index) => item.id || index.toString()}
				renderItem={renderOptionItem}
				showsVerticalScrollIndicator={true}
				contentContainerStyle={{ paddingBottom: 16 }}
				style={{ flex: 1 }}
				keyboardShouldPersistTaps="handled"
				keyboardDismissMode="on-drag"
			/>
		</Modal>
	);
};
